<fa-icon
  [icon]="faSpinner"
  [animation]="'spin'"
  [size]="size()">
</fa-icon>
